import React, { useRef } from 'react'
import { useRecordContext, useTranslate } from 'react-admin';
import { Download } from '@mui/icons-material';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';

export const HotelsInfoModal = ({open, handleClose}) => {

    const record = useRecordContext()
    const info = record?.hotels
    const boxRef = useRef(null);
    const translate = useTranslate()

    const handleDownload = () => {
        const text = boxRef.current.innerText;

        const blob = new Blob([text], { type: "text/plain;charset=utf-8" });
        const url = URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = "tour_information.txt";
        a.click();

        URL.revokeObjectURL(url);
    };


    if (
        info &&
        Array.isArray(info) &&
        info.length > 0
    ) {
        /* const cleanedInfo = cleanConditions(info); */

        return (
        <Dialog open={open} maxWidth='lg' fullWidth={true} onClose={handleClose}>
            <DialogTitle>
                <Typography variant='h6' component='div' textAlign={'center'}>
                {translate('ra.field.provided_hotels')}
                </Typography>
            </DialogTitle>
            <DialogContent>
                <div style={{display:'flex', flexDirection:'row', justifyContent:'flex-end'}}>
                    <Download style={{cursor:'pointer'}} onClick={handleDownload}/>
                </div>
            <Box ref={boxRef} style={{ border: '4px solid #F9F9FD', borderRadius: '10px', padding: 10 }}>
                {info.map((elem, key) => (
                <div key={key}>
                    <div style={{display:'flex', flexDirection:'row', marginBottom:'10px'}}>
                        <label style={{fontWeight:'bold'}}>
                            {`${translate('ra.field.category')}: `}
                        </label>
                        <label style={{marginLeft:'10px'}}>
                            {elem.category}
                        </label>
                    </div>
                    <div style={{display:'flex', flexDirection:'row', flexWrap:'nowrap'}}>
                        {elem.cities?.map(city=>(
                            <div style={{display:'flex', flexWrap:'nowrap', marginRight:'15px',flexDirection:'column'}}>
                                <label style={{fontWeight:'bold'}}>
                                    {city?.city}
                                </label>
                                {city.hotels?.join(',')}
                            </div>
                        ))}
                    </div>
                    <hr />
                </div>
                ))}
            </Box>
            <DialogActions className='dialog-actions' style={{ marginTop: '20px' }}>
                <Button onClick={handleClose} variant='outlined' color='error'>
                {translate('ra.action.close')}
                </Button>
            </DialogActions>
            </DialogContent>
        </Dialog>
        )
    }
    return null;
}
